import { create } from 'lib/init-apollo';

export const apolloClient = create({
  initialState: {}
});
